import moment from 'moment';
import CRUDgeneric from 'utils/CRUDgeneric';
import { formatReceived } from 'utils/formatValues';
import API from 'utils/api';
import { onError } from 'utils/handlers';

// Defino a donde el cliente consumira los enpoints.
export const urlAgregarGuardias = '/nominas/registro-dias-guardia-fechas-agregar/';
export const fechasName = 'fechas';
export const numeroDiasName = 'numero_dias';
const _cliente = CRUDgeneric('/nominas/registro-dias-guardia-fechas/');
// El nombre del modelo que aparecera al agregar y editar.
const _nameModel = 'Fechas Asignadas a Guardia';
// El nombre del modelo para mencionar al nombre del registro.
const _nameModelSingular = 'Las Fechas Asignadas a Guardia';

// Formatea el registro antes insertarlo al form.
const _formatRecordForRead = (record) => record;
// Formatea el registro antes de enviarlo al backend.
/** necesario en fechas, de lo contrario solo volver a mandar el record */
const _formatRecordForSend = (record) => record;

/**
 * Creates a list of moment dates between two moments (inclusive)
 *
 * @param {moment.Moment} start
 * @param {moment.Moment} end
 * @param {boolean} excludeNonWorkingDays - default true
 * @returns {moment.Moment[]}
 */
export const buildDateRange = (
  start,
  end,
  excludeNonWorkingDays = true,
) => {
  if (!moment.isMoment(start) || !moment.isMoment(end)) return [];
  if (!start.isValid() || !end.isValid()) return [];
  if (start.isAfter(end)) return [];

  const dates = [];
  const current = start.clone();

  while (current.isSameOrBefore(end, 'day')) {
    const dayOfWeek = current.day(); // 0 = Sunday, 6 = Saturday

    const isWorkingDay = dayOfWeek !== 0 && dayOfWeek !== 6;

    if (!excludeNonWorkingDays || isWorkingDay) {
      dates.push(current.clone());
    }

    current.add(1, 'day');
  }

  return dates;
};

// Empaqueto todo en un objeto
/** permite llamarlo facilmente por el editor */
export const ModelRegistroGuardiasFechas = {
  cliente: _cliente,
  nameModel: _nameModel,
  nameModelSingular: _nameModelSingular,
  formatter: { // el actor que formatea.
    formatRecordForRead: _formatRecordForRead,
    formatRecordForSend: _formatRecordForSend,
  },
};

/**
 * GET Guardias Vacacionales Periodos
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getRegistroGuardiasFechas = async (params) => (
  _cliente.obtenerListaDeRegistros(params)
);

/**
 * GET Fechas que el empleado ya tiene registradas como Vacación disfrutada.
 * Se usan para bloquear esos días en el calendario de Registro de Guardias,
 * ya que un mismo día no puede ser a la vez Guardia y Vacación disfrutada.
 * @param {number} empleado
 * @returns {Promise<string[]>}
 */
export const getFechasOcupadasPorVacacion = async (empleado) => {
  if (!empleado) return [];
  try {
    const response = await API.get('/nominas/vacaciones-empleados-dias-disfrutados-fechas-ocupadas/', {
      params: { empleado },
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
